const english = {
    // common
    "Add": "Add",
    "AddNew": "Add New",
    "All": "All",
    "Assets": "Assets",
    "Cancel": "Cancel",
    "Clear": "Clear",
    "Clone": "Clone",
    "Close": "Close",
    "Create": "Create",
    "DefaultError": "An error occurred",
    "Delete": "Delete",
    "Edit": "Edit",
    "Copy": "Copy",
    "Email": "Email",
    "Empty": "Empty",
    "Id": "Id",
    "Loading": "Loading...",
    "LoadMore": "Load More",
    "Login": "Login",
    "BackToLogin": "Back to login",
    "Move": "Move",
    "Name": "Name",
    "No": "No",
    "None": "None",
    "NoOptions": "No matching options",
    "Open": "Open",
    "Password": "Password",
    "Profile": "Profile",
    "Refresh": "Refresh",
    "Retry": "Retry",
    "Save": "Save",
    "SaveAndClone": "Save and Clone",
    "Select": "Select",
    "SelectAll": "Select All",
    "Search": "Search",
    "SignOut": "Sign out",
    "Submit": "Submit",
    "UnknownError": "Something went wrong",
    "Username": "Username",
    "Yes": "Yes",
    "Ok": "Ok",
    "Confirm": "Confirm",
    "Continue": "Continue",
    "Error": "Error",
    "ToggleMenu": "Toggle Menu",
    "Upload": "Upload",
    "WedgeScannerUsePrompt": "You can use wedge scanner here",

    "SignUp": "Sign Up",
    "CreateNewAccount": "Create New Account",
    "FirstName": "First Name",
    "LastName": "Last Name",
    "Phone": "Phone",
    "Company": "Company",
    "CreateAccount": "Create Account",
    "ConnectionError": "Sorry, we couldn't connect to the server",

    // Grid
    "Grid.NoItems": "No items",
    "Grid.RowsPerPage": "Rows per page",
    "Grid.PaginationIndex": "{{startIndex}}-{{endIndex}} of {{total}}",
    "Grid.ToggleColumns": "Columns",
    "Grid.ShowAllColumns": "Show All",
    "Grid.HideAllColumns": "Hide All",
    "Grid.FilterNoMatch": "No matching columns",
    "Grid.ResetFilters": "Reset filters",
    "Grid.Refresh": "Refresh",
    "Grid.ColumnsCount": "{{selected}}/{{total}}",

    // Date Range Picker
    "DateRange.From": "From",
    "DateRange.To": "To",
    "DateRange.Clear": "Clear",
    "DateRange.Apply": "Apply",

    // Export
    "Export": "Export",
    "Export.All": "All",
    "Export.Search": "Search results",
    "Export.Cancel": "Cancel Export",
    "Export.Success": "Export completed. Your download is ready.",
    "Export.Failed": "Export failed. Please try again.",
    "Export.Cancelled": "Export has been cancelled.",
    "Export.Started": "Export in progress. You will be notified when it's ready for download.",
    "Export.FailedToStart": "Failed to start export. Please try again.",

    // Download
    "Download": "Download",
    "Download.Progress": "Please wait while the file is being generated.",
    "Download.Error": "Something went wrong. Please try again.",
    "Download.Prompt": "Your download will begin automatically. If it didn't start, click download.",
    "Download.Retry": "Retry",

    // Report
    "Report.Generate": "Generate Report",
    "Report.NoItems": "No reports have been set up in the server.",
    "Reports": "Reports",

    // Help
    "Help.Title": "Help & Support",
    "Help.LogoAlt": "Asset Vue Inventory Logo",
    "Help.AppVersion": "App Version",
    "Help.ApiVersion": "API Version",
    "Help.ContactUs": "Contact Us",
    "Help.EmailSupport": "Email Support",
    "Help.WebSupport": "Web Support",
    "Help.SubmitRequest": "Submit a Request",
    "Help.DeveloperResources": "Developer Resources",
    "Help.Documentation": "Documentation",
    "Help.ApiLinkText": "Asset Vue GraphQL API",
    "Help.IntroDescription": "Need assistance? Contact us or explore our API documentation.",

    // Nav Links
    "Link.Dashboard": "Dashboard",
    "Link.Maintenance": "Maintenance",
    "Link.Assets": "Assets",
    "Link.AssetModels": "Asset Models",
    "Link.AssetTypes": "Asset Types",
    "Link.AssetFields": "Standard Asset Fields",
    "Link.UserDefinedAttributes": "User Defined Attributes",
    "Link.TagPatterns": "Tag Patterns",
    "Link.Scanners": "Scanners",
    "Link.CustomerGroups": "Customer Groups",
    "Link.Users": "Users",
    "Link.Reports": "Reports",
    "Link.Macros": "Macros",
    "Link.FieldPermissions": "Asset Field Permissions",
    "Link.Groups": "Groups",
    "Link.Help": "Help",

    // Login
    "Login.UsernameRequired": "Username is required",
    "Login.PasswordRequired": "Password is required",
    "Login.UsernameCharLimit": "Must be 100 characters or less",
    "Login.UserPasswordError": "Invalid Username or Password",
    "Login.DontHaveAnAccount": "Don't have an account?",
    "Login.CantAccessAccount": "Can't access account?",
    "Login.External": "Login with {{name}}",

    // CreateNewAccount
    "CreateNewAccount.FirstNameRequired": "First Name is required",
    "CreateNewAccount.LastNameRequired": "Last Name is required",
    "CreateNewAccount.CompanyRequired": "Company is required",
    "CreateNewAccount.CharLimit": "Must be 100 characters or less",
    "CreateNewAccount.EmailRequired": "Email is required",
    "CreateNewAccount.InvalidEmailFormat": "Invalid Email format",
    "CreateNewAccount.PhoneNumberRequired": "Phone Number is required",
    "CreateNewAccount.InvalidPhoneNumber": "Invalid Phone Number",
    "CreateNewAccount.CompanyAlreadyExists": "Company already exists",
    "CreateNewAccount.EmailAlreadyExists": "Email already exists",
    "CreateNewAccount.CaptchaRequired": "Captcha is required",
    "CreateAccount.HaveAnAccount": "Already have an account?",

    //Reset Password
    "ResetPassword.UserNameRequired": "Please specify your username",
    "ResetPassword": "Reset Password",
    "ResetPassword.LookForEmail": "Look for an email in your inbox to reset your password",
    "ResetPassword.MailSent": "Reset Password - Email Sent",

    // Details Pane
    "Details": "Details",
    "Details.Assets": "Assets",
    "Details.InventoryState": "Inventory State",
    "Details.Show": "Show details pane",
    "Details.Hide": "Hide details pane",

    // Folder
    "Folder": "Folder",
    "Folder.Empty": "This folder is empty",
    "Folder.Name": "Name",
    "Folder.Name.CharLimit": "Folder name can be at most 1000 characters. Current length is {{length}}",
    "Folder.Name.ContainsPathSeparator": "Folder name should not contain '/'",
    "Folder.Path": "Path",
    "Folder.AddNew": "Add New Folder",
    "Folder.Edit": "Edit Folder",
    "Folder.FolderNameAlreadyExists": "Folder {{name}} already exists in the destination",
    "Folder.CreateNewFolder": "Create New Folder",
    "Folder.NotEmpty": "Children exists for {{id}} ",
    "Folder.CreatedBy": "Created By",
    "Folder.CreatedOn": "Created On",
    "Folder.LastModified": "Last Modified",
    "Folder.LastModifiedBy": "Last Modified By",

    // Asset
    "Asset": "Asset",
    "Asset.Name": "Asset Name",
    "Asset.Model": "Model",
    "Asset.ModelId": "Model",
    "Asset.ModelName": "Model Name",
    "Asset.Placement": "Placement",
    "Asset.ParentAsset": "Parent Asset",
    "Asset.ParentAssetId": "Parent Asset",
    "Asset.ParentFolder": "Parent Folder",
    "Asset.ParentFolderId": "Parent Folder",
    "Asset.SerialNumber": "Serial Number",
    "Asset.Customer": "Customer",
    "Asset.CustomerId": "Customer",
    "Asset.Description": "Description",
    "Asset.RequiresTagNumber": "Requires Tag Number",
    "Asset.TagNumber": "Tag Number",
    "Asset.AlternateTagNumber": "Alternate Tag Number",
    "Asset.VerificationStatus": "Verification Status",
    "Asset.VerificationStatusId": "Verification Status",
    "Asset.Status": "Inventory State",
    "Asset.AssetStatusId": "Inventory State",
    "Asset.AssetClass": "Asset Class",
    "Asset.AssetType": "Asset Type Name",
    "Asset.FolderPath": "Folder Path",
    "Asset.Id": "Id",
    "Asset.ThirdPartyId": "Third Party Id",
    "Asset.Manufacturer": "Manufacturer",
    "Asset.LastModified": "Last Modified",
    "Asset.Created": "Date Added",
    "Asset.LastScanned": "Last Scanned",
    "Asset.Model.Height": "Height",
    "Asset.Model.Width": "Width",
    "Asset.Model.Depth": "Depth",
    "Asset.Model.NumberOfSlots": "Number of Slots",
    "Asset.Model.Description": "Model Description",
    "Asset.Location": "Location",
    "Asset.Group": "Group",
    "Asset.GroupId": "Group",

    "Asset.AddNew": "Add New Asset",
    "Asset.Edit": "Edit Asset",
    "Asset.BasicInfo": "Basic Info",
    "Asset.UserDefinedFields": "User Defined Fields",
    "Asset.UserDefinedFields.Empty": "No user defined fields",
    "Asset.Tabs": "Asset Tabs",
    "Asset.InfoTab": "Asset Info",
    "Asset.ScanHistoryTab": "Scan History",
    "Asset.NotesTab": "Notes",
    "Asset.AttachmentsTab": "Attachments",
    "Asset.AssetHistory": "Asset History",
    "Asset.Empty": "No assets",
    "Asset.ContainedAsset": "Contained Asset",
    "Asset.SubContainedAsset": "Sub-contained Asset",
    "Asset.License.Exceeded": "Allowed asset count for this account has been exceeded.",
    "Asset.TagRedirect.MultipleAssetsFound": "Multiple assets found with the same tag number. Redirecting to the first match.",
    "Assets.Manage": "Manage Assets",
    "Assets.AutoRefresh": "Auto refresh",

    // Select Asset
    "SelectAsset.Search": "name/serial number/tag number",
    "SelectAsset.Folder": "Search Folder",

    // Consumable
    "Consumable": "Consumable",

    // Mass Update Panel
    "MassUpdate.Panel": "Mass Update Panel",
    "MassUpdatePanel.EmptyValueClearsProperty": "Leave empty to clear existing value",
    "MassUpdatePanel.Empty": "No update actions available",
    "MassUpdatePanel.Errors": "Mass Update Failed",
    "MassUpdatePanel.ErrorsDescription": "No assets were updated. Please review the errors below.",

    // Asset Field
    "AssetField": "Asset Field",
    "AssetField.Name": "Name",
    "AssetField.Required": "Required",
    "AssetField.Unique": "Unique",
    "AssetField.Ordinal": "Order",
    "AssetField.Edit": "Edit Asset Field",
    "AssetField.Maintenance": "Manage Asset Fields",

    // User Defined Field
    "UserDefinedField": "User Defined Attribute",
    "UserDefinedField.Name": "Key",
    "UserDefinedField.Type": "Field Type",
    "UserDefinedField.AllowedValues": "Allowed Values",
    "UserDefinedField.Required": "Required",
    "UserDefinedField.Unique": "Unique",
    "UserDefinedField.Ordinal": "Order",
    "UserDefinedField.AppliesTo": "Applies To",
    "UserDefinedField.AssetTypes": "Asset Types",
    "UserDefinedField.Expression": "Expression",
    "UserDefinedField.Maintenance": "Manage User Defined Attributes",
    "UserDefinedField.Edit": "Edit User Defined Attribute",
    "UserDefinedField.Add": "Add User Defined Attribute",
    "UserDefinedField.AllowedValues.HelperText": "Separate allowed values with commas",
    "UserDefinedField.AllowedValues.LengthError": "Each value should be fewer than 100 characters",
    "UserDefinedField.Name.Exists": "User defined key, {{name}}, already exists",
    "UserDefinedField.Name.Reserved": "{{name}} is a reserved name",
    "UserDefinedField.Expression.ParseError": "Failed to parse the expression",
    "UserDefinedField.Unique.DuplicatesError": "This field cannot be updated to unique as it already has duplicate values",

    // Field Types
    "DATE": "Date",
    "NUMBER": "Number",
    "PICKLIST": "Picklist",
    "TEXT": "Text",
    "CALCULATED": "Calculated",

    // Applies to
    "ALL": "All",
    "SERIALIZED_ASSETS": "Serialized Assets",
    "CONSUMABLES": 'Consumables',
    "SPECIFIC_ASSET_TYPES": 'Specific Asset Types',

    // Delete
    "DeletePopupTitle": "Delete $t({{type}})",
    "DeleteConfirmation": "You are about to delete the $t({{type}}), '{{name}}'",

    // Validations
    "RequiredField": "This field is required",
    "NamedRequiredField": "$t({{name}}) is required",
    "CharLimit": "Must be {{length}} characters or less",
    "UnableToValidate": "Could not validate. Please try again",
    'EditCancelPrompt': 'You might lose your changes. Continue anyway?',
    "InvalidDate": "Please enter a valid date",
    "InvalidNumber": "Please enter a valid number",
    "NumberOutOfBounds": "Number should be between {{min}} and {{max}}",
    "AlreadyInUse": "This $t({{name}}) is already in use",
    "UniqueField": "This value is already in use",

    // Notifications
    "Notify.Saved": "$t({{name}}) was successfully saved!",
    "Notify.Deleted": "$t({{name}}) was successfully deleted!",
    "Notify.DeleteFailed.Unknown": "Failed to delete the $t({{name}})!",
    "Notify.DeleteFailed.InUse": "The $t({{name}}) is in use and cannot be deleted!",
    "Notify.CorrectErrors": "Please correct the errors before continuing!",
    "Notify.PermissionsSuccess": "Permissions updated successfully!",
    "Notify.DeleteFailed.InUse.Group": "Group is in use by Assets or Users and cannot be deleted!",
    "Notify.DeleteFailed.InUse.Model": "Model is in use by Assets and cannot be deleted!",
    "Notify.DeleteFailed.InUse.AssetType": "The Asset Type is in use by Asset Models or User Defined Fields and cannot be deleted!",
    "Notify.DeleteFailed.InUse.Folder": "Folder is not empty and cannot be deleted!",
    "Notify.DeleteFailed.InUse.Asset": "Asset contains child assets and cannot be deleted!",
    "Notify.DeleteFailed.InUse.UserDefinedField": "This field is being referenced in calculated fields and/or macros and cannot be deleted!",
    "Notify.ResendInvite": "Invitation to the user was successfully resent!",
    "Notify.SetDisplayImage": "Display image was successfully generated!",
    "Notify.SetDisplayImage.Error": "Something went wrong. Image format/size could be unsupported.",

    // units
    "Asset.CountWithUnit_one": "{{count}} asset",
    "Asset.CountWithUnit_other": "{{count}} assets",
    "ContainedAsset.CountWithUnit_one": "{{count}} contained asset",
    "ContainedAsset.CountWithUnit_other": "{{count}} contained assets",
    "Sub-containedAsset.CountWithUnit_one": "{{count}} sub-contained asset",
    "Sub-containedAsset.CountWithUnit_other": "{{count}} sub-contained assets",
    "Folder.CountWithUnit_one": "{{count}} folder",
    "Folder.CountWithUnit_other": "{{count}} folders",
    "Error.CountWithUnit_one": "{{count}} error",
    "Error.CountWithUnit_other": "{{count}} errors",
    "Warning.CountWithUnit_one": "{{count}} warning",
    "Warning.CountWithUnit_other": "{{count}} warnings",
    "Verified.CountWithUnit_one": "{{count}} verified",
    "Verified.CountWithUnit_other": "{{count}} verified",
    "Missing.CountWithUnit_one": "{{count}} missing tag or asset",
    "Missing.CountWithUnit_other": "{{count}} missing tags or assets",
    "SelectedItems": "{{count}} selected",
    "Scan.TagsFound_one": "{{count}} tag scanned",
    "Scan.TagsFound_other": "{{count}} tags scanned",
    "Scan.AssetsFound_one": "{{count}} asset scanned",
    "Scan.AssetsFound_other": "{{count}} assets scanned",
    "ContainerScan.Found": "{{count}} found",
    "ContainerScan.New": "{{count}} new",
    "ContainerScan.Moved": "{{count}} moved",
    "ContainerScan.Missing": "{{count}} missing",
    "ContainerScan.Expected": "{{count}} expected",
    "Assets.Selected_one": "{{count}} asset selected",
    "Assets.Selected_other": "{{count}} assets selected",
    "Attachments.FilesSelected_one": "{{count}} file selected",
    "Attachments.FilesSelected_other": "{{count}} files selected",
    "Upload.ChooseFiles_one": "Drag and drop or Choose your file",
    "Upload.ChooseFiles_other": "Drag and drop or Choose your files",

    // Verification Status
    "Verified": "Verified",
    "Tag Missing": "Tag Missing",
    "Not Verified": "Not Verified",
    "Missing In Scan": "Missing In Scan",
    "Moved": "Moved",
    "Portal Scan": "Portal Scan",
    "Confirmed Missing": "Confirmed Missing",

    // Asset Class
    "BASE": "Base",
    "CONTAINED": "Contained",
    "SUB_CONTAINED": "Sub-contained",
    "NON_MOUNTED": "Non-mounted",
    "AssetClass.All": "All classes",

    // Asset Type
    "AssetType": "Asset Type",
    "AssetType.Name": "Name",
    "AssetType.Name.CharLimit": "Asset type name can be at most 1000 characters. Current length is {{length}}",
    "AssetType.Add": "Add New Asset Type",
    "AssetType.Edit": "Edit Asset Type",
    "AssetType.AssetTypeNameAlreadyExists": "Asset Type name {{name}} already exists",
    "AssetType.Empty": "No asset types",
    "AssetType.Maintenance": "Manage Asset Types",

    // Model
    "Model": "Model",
    "Model.Name": "Model Name",
    "Model.Manufacturer": "Manufacturer",
    "Model.Description": "Description",
    "Model.ProductLine": "Product Line",
    "Model.AssetType": "Asset Type Name",
    "Model.AssetClass": "Asset Class",
    "Model.Height": "Height",
    "Model.Width": "Width",
    "Model.Depth": "Depth",
    "Model.HeightInRackUnits": "Height in Rack Units",
    "Model.InRackUnits": "In Rack Units",
    "Model.NumberOfSlots": "Number of Slots",
    "Model.Maintenance": "Manage Asset Models",
    "Model.Empty": "No asset models",
    "Model.Edit": "Edit Asset Model",
    "Model.AddNewAssetModel": "Add New Asset Model",
    "Model.Name.Search": "Search model name",
    "Model.Description.Search": "Search description",
    "Model.ProductLine.Search": "Search product line",
    "Model.ModelNameAlreadyExists": "The Asset Model {{name}} already exists",

    // Manufacturer
    "Manufacturer.Name": "Manufacturer Name",
    "Manufacturer.AddNew": "Add New Manufacturer",
    "Manufacturer.AddPrompt": "Add \"{{name}}\"",

    // Scanner
    "Scanner": "Scanner",
    "Scanner.Maintenance": "Manage Scanners",
    "Scanner.Name": "Name",
    "Scanner.Type": "Type",
    "Scanner.FolderAndContainer": "Folder/Container",
    "Scanner.LastHeartbeat": "Last Communication",
    "Scanner.AllowMacros": "Allow Macros",
    "Scanner.AllowRealtimeMove": "Allow Realtime Move",
    "Scanner.AllowAutoCreate": "Allow Auto Create",
    "Scanner.Add": "Add Scanner",
    "Scanner.Edit": "Edit Scanner",
    "Scanner.Folder": "Folder",
    "Scanner.Asset": "Container",
    "Scanner.TotalScans": "Scan Count",
    "Scanner.MacrosAllowed": "Macros allowed",

    // Macro
    "Macro": "Macro",
    "Macro.Maintenance": "Manage Macros",
    "Macro.Name": "Name",
    "Macro.Type": "Type",
    "Macro.CompareOriginal": "Compare to original value",
    "Macro.Add": "Add",
    "Macro.Edit": "Edit",
    "Macro.Scanner.Name": "Scanner Name",
    "Macro.Tasks": "Tasks",
    "Macro.Task.Ordinal": "Order",
    "Macro.Task.Property": "Property",
    "Macro.Task.Type": "Type",
    "Macro.Task.Value": "Value",
    "Macro.Task.EmptyValueClearsProperty": "Clear if empty",
    "Macro.Task.Add": "Add Task",
    "Macro.Task.Delete": "Remove macro task",
    "Macro.Rules": "Rules",
    "Macro.Rule.Delete": "Remove rule",
    "Macro.Rule.Comparison": "Comparison",
    "Macro.Rule.Property": "Property",
    "Macro.Rule.Value": "Value",
    "Macro.Rule.Connector": "Connector",
    "Macro.Rule.Negate": "Negate",
    "Macro.Rule.Add": "Add Rule",
    "Macro.Rule.Group.Connector": "Connector",
    "Macro.Rule.Group.Add": "Add Group",
    "Macro.Rule.Group.Delete": "Remove group",
    "Macro.Rule.Group.MinimumTwoRules": "A group must contain at least two rules",
    "Macro.Rule.NoRulesAlwaysExecutes": "No rules defined. This macro will always execute.",
    "Macro.Rule.Comparison.Unsupported": "Unsupported comparison",
    "Macro.Rule.MoveUp": "Move rule up",
    "Macro.Rule.MoveDown": "Move rule down",
    "Macro.Rule.Group.MoveUp": "Move group up",
    "Macro.Rule.Group.MoveDown": "Move group down",

    "Macro.Type.All": "All",
    "Macro.Type.ON_INSERT": "On Insert",
    "Macro.Type.ON_UPDATE": "On Update",
    "Macro.Type.ON_DELETE": "On Delete",
    "Macro.Type.ON_SCAN": "On Scan",
    "Macro.Type.MANUAL": "Mass Update Panel",
    "Macro.Task.Type.SET_PROPERTY": "Set Property",
    "Macro.Task.Type.SEND_EMAIL": "Send Email",
    "Macro.AssetProperties": "Asset Properties",
    "Macro.UserDefinedFields": "User Defined Fields",
    "Macro.UserFields": "User Fields",

    "Comparison.EQUAL": "Equals",
    "Comparison.NOT_EQUAL": "Not equals",
    "Comparison.GREATER_THAN": "Greater than",
    "Comparison.GREATER_THAN_OR_EQUAL": "Greater than or equal",
    "Comparison.LESS_THAN": "Less than",
    "Comparison.LESS_THAN_OR_EQUAL": "Less than or equal",
    "Comparison.STARTS_WITH": "Starts with",
    "Comparison.ENDS_WITH": "Ends with",
    "Comparison.CONTAINS": "Contains",
    "Connector.AND": "And",
    "Connector.OR": "Or",

    // User
    "User": "User",
    "User.Name": "Name",
    "User.FirstName": "First Name",
    "User.LastName": "Last Name",
    "User.Username": "Username",
    "User.Email": "Email",
    "User.Role": "Role",
    "User.RoleName": "Role",
    "User.AccountName": "Account",
    "User.UseEmailAsUsername": "Use my email as Username",
    "User.AddNewUser": "Add New User",
    "User.UserNameAlreadyExists": "Username '{{username}}' already exists",
    "User.ReadOnly": "Read Only Access",
    "User.Invite": "Invite",
    "User.Scanner": "Scanner",
    "User.Groups": "Groups",
    "User.Status": "Invite Status",
    "User.Edit": "Edit User",
    "User.ResendInvite": "Resend Invite",
    "User.CancelInvite": "Cancel Invite",
    "User.Delete": "Delete",
    "User.EmailAlreadyExists": "Email '{{email}}' already exists",
    "User.ResendInviteConfirmation": "Do you want to resend the invitation to the User '{{name}}'?",
    "User.ResendInviteTitle": "Resend Invite",
    "User.Management": "User Management",

    // Import
    "Import": "Import",
    "Import.Logs": "Import Logs",
    "Import.GoToExisting": "Go to existing import",
    "Import.By": "Import processed by {{name}}",
    "Import.Commit": "Commit",
    "Import.StartedAt": "Started on",
    "Import.FinishedAt": "Completed on",
    "Import.Status.IN_PROGRESS": "In progress",
    "Import.Status.IN_PROGRESS.Message": "Import in progress. Rows are being validated. Please wait until the assets are staged.",
    "Import.Status.FAILED": "Failed",
    "Import.Status.FAILED.Message": "The import was failed. Check logs to see errors.",
    "Import.Status.STAGED": "Staged",
    "Import.Status.STAGED.Message": "Import is validated and staging is complete. Commit import to save assets or cancel the import to start a new one.",
    "Import.Status.SUCCEEDED": "Success",
    "Import.Status.SUCCEEDED.Message": "The import was successfully completed.",
    "Import.Status.CANCELLED": "Cancelled",
    "Import.Status.CANCELLED.Message": "The import was cancelled by user.",
    "Import.Status.COMMITTING": "Commit in progress",
    "Import.Status.COMMITTING.Message": "The import is confirmed. Please wait while the assets are being saved.",
    "Import.FileName": "File Name ",
    "Import.Assets": "Import Assets",
    "Import.Select": "Select",
    "Import.Upload": "Upload",
    "Import.SelectFile": "Please select a CSV file",
    "Import.FileSizeLimit": "File size should be less than {{size}}",
    "Import.Success": "Import has completed successfully",
    "Import.Failed": "Import has failed",
    "Import.Results": "Import Results",
    "Import.CreateNewFolders": "Create missing folders in folder paths",
    "Import.Log.ShowInfos": "Show infos",
    "Import.Log.ShowWarnings": "Show warnings",
    "Import.Log.ShowErrors": "Show errors",
    "Import.Log.Empty": "No items",
    "Import.Log.LoadNew": "Load new logs",
    "Import.Log.Sort": "Sort by newest/oldest",
    "Import.Log.Export": "Export logs to CSV",

    // Bulk Delete
    "BulkDelete": "Bulk Delete",
    "BulkDelete.Completed": "Completed",
    "BulkDelete.CompletedWithErrors": "Completed with errors",
    "BulkDeleteAssets": "Bulk Delete Assets",
    "BulkDeleteAssets.DeletedCountOutOfTotal": "Deleted {{deleted}} out of {{total}} assets.",
    "BulkDelete.UploadPrompt": "Upload a CSV file with either Asset Ids or Tag Numbers to delete them.",

    // Group
    "Group": "Group",
    "Group.Name": "Name",
    "Group.Add": "Add Group",
    "Group.Edit": "Edit Group",
    "Group.Maintenance": "Manage Groups",

    // Scanner Type
    "Scanner.Type.All": "All",
    "PORTAL": "Portal",
    "WEDGE": "Wedge",
    "REALTIME_CONTAINER": "Realtime Container",
    "REALTIME_FOLDER": "Realtime Folder",

    // Roles
    "Admin": 'Admin',
    "General User": 'General User',
    "Customer": 'Customer',
    "Super User": 'Super User',
    "System Admin": 'System Admin',

    //YesNo
    "YES": 'Yes',
    "NO": 'No',

    //Tag Patterns
    "TagPattern": "Tag Pattern",
    "TagPattern.Pattern": "Pattern",
    "TagPattern.Name.CharLimit": "Recognized Tag Pattern can be at most 20 characters. Current length is {{length}}",
    "TagPattern.Add": "Add New Recognized Tag Pattern",
    "TagPattern.Edit": "Edit Recognized Tag Pattern",
    "TagPattern.TagPatternAlreadyExists": "The Tag Pattern {{name}} already exists",
    "TagPattern.Empty": "No Recognized Tag Patterns",
    "TagPattern.Maintenance": "Manage Recognized Tag Number Patterns",

    // Scan
    "Scan.QuickScan": "Quick Scan",
    "Scan.ContainerScan": "Container Scan",
    "Scan.SelectContainer": "Select Container",
    "Scan.Stop": "Stop",
    "Scan.StopPrompt": "Stop scanning to view or edit asset details",
    "Scan.Failed": "Failed to save scan",
    "Scan.Retry": "Retry",
    "Scan.NotFound": "Tag not assigned",
    "Scan.HideUnknownTags": "Hide unknown tags",
    "Scan.QuickScanResults": "Quick Scan Results",
    "Scan.ContainerScanResults": "Container Scan Results",
    "Scan.NoScanSession": "No Active scan session",
    "Scan.NewTagsScanned": "New tags scanned",
    "Scan.TagNumber": "Tag Number",
    "Scan.ScannedTagNumber": "Scanned Tag Number",
    "Scan.ScanDateUser": "Scan Date / Scanned By",
    "Scan.AssetNameSerialNumber": "Container Asset / Serial Number",
    "Scan.ManufacturerModel": "Manufacturer / Model ",
    "Scan.Folder": "Folder",
    "Scan.Antenna": "Antenna",
    "Scan.Scanned": "Scanned on",
    "Scan.NoItems": "No items",
    "Scan.ClickToSeeNewTags": "Click to see new tags scanned",
    "Scan.NewTag.AddNewAsset": "Add New Asset",
    "Scan.NewTag.AssignToExistingAsset":"Assign to Existing Asset",
    "Scan.NewTag.SaveAssetPrompt":"Applied the new tag number. Please save the asset to continue.",

    // Scan result status
    "ScanResult.ASSET_FOUND": "Asset found",
    "ScanResult.ASSET_FOUND_BUT_MOVED": "Asset moved",
    "ScanResult.NO_ASSET_ACCESS": "Access denied to the asset",
    "ScanResult.NEW_TAG": "Tag not assigned",
    "ScanResult.DUPLICATE_SCAN": "Scan already exists in this session",
    "ScanResult.INVALID_TAG": "Invalid tag",
    "ScanResult.INVALID_TAG_PATTERN": "Tag pattern not recognized",

    //User Profile
    "UserProfile": "User Profile",
    "UserProfile.Edit": "Edit User Profile",
    "UserProfile.TimeZone": "Time Zone",
    "UserProfile.ViewProfile": "View Profile",

    // View
    "View": "View",
    "Views": "Views",
    "View.Viewers": "Viewers",
    "View.Private": "Private",
    "View.Public": "Public",
    "View.PublicView": "Public view",
    "View.Default": "Default",
    "View.Default.Prompt": "Use this view as the initial default view for all users.",
    "View.SwitchView": "Switch View",
    "View.Save": "Save",
    "View.SaveAs": "Save As",
    "View.SavePrompt": "Save current view",
    "View.SaveAsPrompt": "Save current view as a new view",
    "View.Name": "Name",
    "View.Settings": "View Settings",
    "View.Add": "Add View",
    "View.Edit": "Edit View",
    "View.Manage": "Manage Views",
    "View.None": "Search All Assets",
    "View.MarkAsDefault": "Mark as Default",
    "View.RemoveDefault": "Remove Default",
    "View.PublicDefault.Prompt": "This view is marked as default.",

    //Change Password
    "ChangePassword.CurrentPassword": "Current Password",
    "ChangePassword.CurrentPasswordRequired": "Current Password is required",
    "ChangePassword.PasswordRequired": "New Password is required",
    "ChangePassword.IncorrectPassword": "Current password is incorrect",
    "ChangePassword.PasswordsDoNotMatch": "Passwords do not match",
    "ChangePassword.PasswordChanged": "Your password has been updated. Please login again.",
    "ChangePassword.ConfirmPasswordRequired": "Confirm Password is required",
    "ChangePassword.ConfirmPassword": "Confirm Password",
    "ChangePassword.NewPassword": "New Password",
    "ChangePassword.Length": "At least {{length}} characters",
    "ChangePassword.AtLeastOneLowerCase": "At least one lower case letter",
    "ChangePassword.AtLeastOneUpperCase": "At least one upper case letter",
    "ChangePassword.AtLeastOneDigit": "At least one number",
    "ChangePassword.OneSpecialCharacter": "At least one special character",
    "ChangePassword.LinkExpired": "Your Asset Vue Password Reset link has expired",
    "ChangePassword.ChangePassword": "Change Password",
    "ChangePassword.ChangeMyPassword": "Change My Password",
    "ChangePassword.RequirePasswordChange": "Require Password Change",
    "ChangePassword.Changed": "Password Changed",

    // Asset History
    "AssetHistory.Empty": "none",
    "AssetHistory.UnknownUser": "Unknown User",
    "AssetHistory.UserEntry.CREATE": "<strong>{{name}}</strong> created the asset",
    "AssetHistory.UserEntry.UPDATE": "<strong>{{name}}</strong> made the following changes",
    "AssetHistory.UserEntry.DELETE": "<strong>{{name}}</strong> deleted the asset",
    "AssetHistory.UserEntry.RESTORE": "<strong>{{name}}</strong> restored the asset",
    "AssetHistory.GenerateTransactionReport": "Generate Transaction Report",

    // Theme
    "Theme": "Theme",
    "Theme.light": "Light",
    "Theme.dark": "Dark",

    // License
    "License": "License",
    "License.Usage": "Used {{count}} of {{total}} assets allowed ({{percentage}}%)",
    "License.Exceeded": "License count for this account has been exceeded.",
    "License.Warning": "Addition of new assets will be restricted after 105% of allowed assets.",
    "License.Error": "Addition of new assets is restricted as the asset count is more than the allowed asset count.",
    "License.ContactEmail": "Please contact <emailLink href='mailto:{{email}}'>{{email}}</emailLink>",

    "Database.PendingChanges": "Database has pending changes.",

    // Attachments
    "Attachment": "Attachment",
    "Attachment.Filename": "Filename",
    "Attachment.MimeType": "Mime Type",
    "Attachment.FileSize": "File Size",
    "Attachment.CreatedBy": "Created By",
    "Attachment.Created": "Created On",
    "Attachment.Add": "Add Attachments",
    "Attachment.Remove": "Remove file",
    "Attachment.SelectFilePrompt": "Please select at least one file to upload",
    "Attachment.HasErrors": "Attached file has errors",
    "Attachment.RemovedFilesWithErrors": "Please remove the files with errors before continuing",
    "Attachment.ExceedsSizeError": "Attached file size should be less than {{size}}",
    "Attachment.InvalidFileType": "Invalid file type",
    "Attachment.ValidExtensions": "Supported file extensions are, {{extensions}}",
    "Attachment.InvalidExtensions": "The following file extensions are not allowed; {{extensions}}",
    "Attachment.UploadSuccess": "Successfully uploaded attachments!",
    "Attachment.NoPreview": "No Preview available",
    "Attachment.Download": "Download",
    "Attachment.Delete": "Delete",
    "Attachment.SetDisplayImage": "Set as Display Image",
    "Attachment.SetDisplayImageConfirmation": "Are you sure you want to set '{{name}}' as the display image for the asset?",

    // Directories
    "Directory.Name": "Name",
    "Directory.Details": "Details",
    "Directory.LastModified": "Last Modified",
    "Directory.DisplayAsIcons": "Display as icons",
    "Directory.DisplayAsList": "Display as list",

    // Field Permissions
    "FieldPermissions.AssetFields": "Asset Fields",
    "FieldPermissions.UserDefinedFields": "User Defined Fields",
    "FieldPermissions.Roles": "Roles",
    "FieldPermissions.FieldName": "Field Name",
    "FieldPermissions.Maintenance": "Manage Asset Field Permissions",

    "Permissions.NONE": "Hidden",
    "Permissions.READ": "View only",
    "Permissions.WRITE": "Write only",
    "Permissions.READ_WRITE": "Editable",
    "Permissions.MarkAllHidden": "Mark all as hidden",
    "Permissions.MarkAllViewOnly": "Mark all as view only",
    "Permissions.MarkAllEditable": "Mark all as editable",
}

export default english;